"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateConfig = void 0;
var validateConfig = function validateConfig(config, key) {
  if (!config[key]) {
    throw new Error("Invalid configuration: ".concat(key, " is required."));
  }
};
exports.validateConfig = validateConfig;